// 14 Zorunlu Alerjen (AB/Türkiye Gıda Mevzuatı)
export const ALLERGENS = [
  { key: 'gluten',      label: 'Gluten',          icon: '🌾', desc: 'Buğday, arpa, yulaf ve türevleri' },
  { key: 'crustaceans', label: 'Kabuklular',       icon: '🦐', desc: 'Karides, yengeç, ıstakoz ve türevleri' },
  { key: 'eggs',        label: 'Yumurta',          icon: '🥚', desc: 'Yumurta ve yumurta ürünleri' },
  { key: 'fish',        label: 'Balık',            icon: '🐟', desc: 'Balık ve balık ürünleri' },
  { key: 'peanuts',     label: 'Yer Fıstığı',      icon: '🥜', desc: 'Yer fıstığı ve türevleri' },
  { key: 'soy',         label: 'Soya',             icon: '🫘', desc: 'Soya fasulyesi ve türevleri' },
  { key: 'milk',        label: 'Süt / Laktoz',     icon: '🥛', desc: 'Süt ve süt ürünleri (laktoz dahil)' },
  { key: 'nuts',        label: 'Kabuklu Yemişler', icon: '🌰', desc: 'Badem, fındık, ceviz, antep fıstığı, kaju vb.' },
  { key: 'celery',      label: 'Kereviz',          icon: '🥬', desc: 'Kereviz sapı, tohumu ve türevleri' },
  { key: 'mustard',     label: 'Hardal',           icon: '🌿', desc: 'Hardal tohumu, yaprağı ve türevleri' },
  { key: 'sesame',      label: 'Susam',            icon: '🌻', desc: 'Susam tohumu ve türevleri' },
  { key: 'sulphites',   label: 'Sülfitler',        icon: '⚗️', desc: 'Kükürt dioksit (SO₂) ve sülfitler' },
  { key: 'lupin',       label: 'Acı Bakla',        icon: '🌱', desc: 'Acı bakla unu, tohumu ve türevleri' },
  { key: 'molluscs',    label: 'Yumuşakçalar',     icon: '🐚', desc: 'Midye, istiridye, kalamar, ahtapot vb.' },
];

// Key ile hızlı lookup (TR fallback — geriye dönük uyumluluk için)
export const ALLERGEN_MAP = Object.fromEntries(ALLERGENS.map(a => [a.key, a]));

// i18n key üretici: 'gluten' → 'allergenGlutenLabel' / 'allergenGlutenDesc'
const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1);

/**
 * i18n-aware allergens listesi. ALLERGENS yapısı aynı, label/desc t() ile değiştirilir.
 * Çeviri yoksa TR fallback (constants'taki orijinal label/desc) döner.
 *
 * @param {Function} t — useLanguage().t
 * @returns {Array<{ key, label, icon, desc }>}
 */
export function getAllergens(t) {
  if (typeof t !== 'function') return ALLERGENS;
  return ALLERGENS.map(a => {
    const cap = capitalize(a.key);
    return {
      ...a,
      label: t(`allergen${cap}Label`) || a.label,
      desc:  t(`allergen${cap}Desc`)  || a.desc,
    };
  });
}

/**
 * i18n-aware ALLERGEN_MAP — key → translated allergen object.
 * @param {Function} t — useLanguage().t
 */
export function getAllergenMap(t) {
  return Object.fromEntries(getAllergens(t).map(a => [a.key, a]));
}
